<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <rect id="rect-1" width="24" height="24" x="0" y="0"/>
      <mask id="mask-2" maskContentUnits="userSpaceOnUse" maskUnits="userSpaceOnUse">
        <rect width="24" height="24" x="0" y="0" fill="black"/>
        <use fill="white" xlink:href="#rect-1"/>
      </mask>
    </defs>
    <g>
      <use fill="none" xlink:href="#rect-1"/>
      <g mask="url(#mask-2)">
        <path fill="rgb(0,0,0)" fill-rule="evenodd" d="M15.32000732 3.05004883l6 2C21.72729492 5.18774414 22.00109863
        5.57006836 22 6v14c-.00146484.32202148-.15777588.62329102-.41998291.8100586C21.41320801 20.93603515
        21.20910645 21.00292968 21 21c-.10614014.0144043-.21380615.0144043-.32000732 0L15 19.05004883l-5.7000122
        1.89990234c-.20141602.06567383-.41851807.06567383-.61999512 0l-6-2C2.27270508 18.8125 1.99890137 18.42993164 2
        18V4c.00152588-.32177734.15783691-.62329102.41998291-.8100586.26013184-.18847656.5949707-.2404785.90002441
        -.13989257L9 5l5.67999268-1.94995117h.42999267c.04656983-.00463867.09350586-.00463867.14001465
         0h.07000732zM4 17.27978516l4 1.33007812V6.7199707L4 5.38989258v11.88989258zm10
         0l-4 1.33007812V6.7199707l4-1.33007812v11.88989258zm2 0l4 1.33007812V6.7199707l-4-1.33007812v11.88989258z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconMap',
};
</script>

<style scoped>

</style>
